<template>

<!-- Top -->
<div id="top"></div>

<!-- Main -->
  <div class="row supervisor-claims-frame">
    <div class="col s12 supervisor-claims-frame-col">

      <LoadingDiv v-if="!isReady" />

      <div class="finance-claims-workbench supervisor-claims-workbench" v-else>

        <div class="premium-queue-head">
          <div class="queue-title-block">
            <label class="active teal-text">Finance Claims</label>
            <h5>Payment Batches</h5>
            <p>{{ batches.length }} {{ batches.length === 1 ? "batch" : "batches" }} showing under {{ currentStateTitle }}.</p>
          </div>

          <div class="scheme-switch">
            <button
              v-for="tab in tabsState"
              :key="tab.id"
              type="button"
              :class="{ 'is-active': tab.id === currState }"
              @click="handleState(tab.id)"
            >
              {{ tab.title.toUpperCase() }}
            </button>
          </div>
        </div>

        <!-- loading -->
        <div class="finance-claims-progress progress" v-if="isLoading">
          <div class="indeterminate"></div>
        </div>

        <div class="payment-batch-head" v-if="batches.length && !currBatch">
          <span>#</span>
          <span>Batch</span>
          <span>Amount</span>
          <span>Status</span>
          <span>Date</span>
          <span></span>
        </div>

        <div v-for="(batch, index) in batches" :key="batch.id">
          <div
            v-if="currBatch == batch || !currBatch"
            class="claim-batch-row"
            :class="{ 'is-open': currBatch == batch }"
          >
            <div class="row mb-zero">
              <div class="col s2 m1 hide-on-small-only">
                <p class="row-index">{{ numberBadge(index) }}</p>
              </div>
              <div class="col s12 m4">
                <h6 class="provider-cell">
                 {{ batch?.scheme?.name ? batch?.scheme?.name.toUpperCase() : "GENERAL" }} 
                 <span class="bill-count-pill">
                   <i class="material-icons tiny">receipt_long</i>
                   {{ batch.clusters_count }} {{ batch.clusters_count > 1 ? "bills" : "bill" }}
                 </span>
                 <br />
                 <small>(Batch #{{ batch.id }})</small>
                 <span v-if="batch.batch_type === 's'" class="batch-type-pill">Supplementary</span>
                </h6>
              </div>
              <div class="col s4 m2 finance-amount-col">
                <p>
                  <span class="chip finance-amount-chip"><b>
                  ₦{{ backendApprovedTotal(batch) }}
                  </b></span>
                </p>
              </div>
              <div class="col s4 m2 finance-status-col">
                <p class="period-cell">
                  <span class="chip finance-status-pending" v-if="batch.stage == 'q'">Pending</span>
                  <span class="chip finance-status-completed center" v-if="batch.stage == 'c'"
                    ><i class="material-icons tiny">check_circle</i>Completed</span
                  >
                </p>
              </div>
              <div class="col s6 m2 finance-date-col">
                <div class="finance-meta-stack">
                  <p class="agent-cell paid-date-pill" title="payment reference">
                    <span title="Payment Reference" v-if="batch.stage == 'q'">N/A</span>
                    <span title="Payment Reference" v-if="batch.stage == 'c'">
                    {{
                      new Date(batch.paid_date).toLocaleString(undefined, {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                      })
                    }}
                    </span>
                  </p>
                </div>
              </div>
              <div class="col s6 m1 finance-action-col" :class="{ 'is-close-action': currBatch }">
                <span v-if="!currBatch">
                  <button type="button" class="row-action right" @click="handleView(batch)" title="details">
                    <i class="material-icons">chevron_right</i>
                  </button>
                </span>
                <span class="right" v-else>
                  <button type="button" class="row-action is-close" @click="handleClear()" title="go back">
                    <i class="material-icons">keyboard_return</i>
                  </button>
                </span>
              </div>
            </div>
          </div>
          </div>

        <!-- Batch details -->
        <BatchDiv
          :batchId="currBatch.id"
          @reset="handleReset"
          v-if="currBatch"
        />

        <!-- Pages -->
        <template v-else>
          <div class="payment-empty-state" v-if="!batches.length">
            <div class="payment-empty-icon">
              <i class="material-icons">payments</i>
            </div>
            <h6>{{ emptyBatchTitle }}</h6>
            <p>{{ emptyBatchDescription }}</p>
          </div>

          <PaginationDiv :payLoad="allPages" @newPage="handlePage" v-else />
        </template>
      </div>
    </div>
  </div>
</template>
              
<script>
import { computed, onMounted, ref, watch } from "vue";
import getItems from "@/composables/getItems";
import BatchDiv from "@/components/finance/FinanceSingleBatchComponent.vue";
import PaginationDiv from "@/components/pager/PaginationDiv.vue";
import LoadingDiv from "@/components/LoadingDiv.vue";
import {
  toMonthYearFx,
} from "@/composables/fxLibrary/coreFx.js";
import {
  batchTotalApprovedFx,
} from "@/composables/calFunction/cal";


export default {
  name: "FinanceClaimsComponent",
  components: { LoadingDiv, PaginationDiv, BatchDiv },
  props: ["resetKey"],
  setup(props) {
    const response = ref(null);
    const isReady = ref(false);
    const reLoad = ref(false);
    const isLoading = ref(true);
    const error = ref(null);
    const currBatch = ref(false);
    const currUrl = ref(null);
    const currHook = ref(null);
    const currServerDate = ref(null);
    const tabsState = ref([]);
    const currState = ref(null);

// start
onMounted(() => {
  // load tab
  tabsState.value.push({ id: "a", title: "All" });
  tabsState.value.push({ id: "u", title: "UnPaid" });
  tabsState.value.push({ id: "p", title: "Paid" });

  // set default (all)
  currState.value = "a";
});

    // numbering
    const numberBadge = (num) => {
      return (
        (allPages.value.current_page - 1) * allPages.value.per_page + num + 1
      );
    };

    // total calculations (clustered approved)
    const batchTotalApproved = (batch) => {
      return batchTotalApprovedFx(batch);
    };

    const backendApprovedTotal = (batch) => {
      return Number(batch.approved_total || 0)
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    // convert to Month & Year
    const toMonthYear = (val) => {
      return toMonthYearFx(val);
    };

    // get function
    const getItemsFromApi = (table) => {
      (async () => {
        const { res, err } = await getItems(table);

        if (res.value) {
          response.value = res.value.data;
        } else {
          error.value = err.value;
        }

        // page is ready, loading is complete
        isReady.value = true;
        isLoading.value = false;
      })();
    };

    // starter
    onMounted(() => {
      // get started
      getPendingBatches("a"); // a=all
    });

    // get fresh load
    const getPendingBatches = (val) => {
      // set current Url
      currUrl.value = `cluster/finance/vetted?s=${val}`;
      // set current Hook
      currHook.value = "&";
      // get items from function
      getItemsFromApi(currUrl.value);
    };

     // change state
     const handleState = (val) => {

// clear all
handleClear();

// set
currState.value = val;
scrollToPageTop();

// restart
getPendingBatches(currState.value);

}

    // update batch
    const handleReset = (val) => {
      // mark for reload
      reLoad.value = true;

      // reset
      if (val != "reload") {
        getPendingBatches(currState.value);
        currBatch.value = null;
      } else if (val == "reload") {
        // handle clear
        handleClear();
      }
    };

    // enrollee action
    const handleClear = () => {
      // reLoad if necessary
      if (reLoad.value) {
        isReady.value = false;
        getPendingBatches(currState.value);
      }
      // clear
      currBatch.value = null;
      reLoad.value = false;
    };

    watch(
      () => props.resetKey,
      () => {
        handleClear();
      }
    );

    // enrollee action
    const handleView = (val) => {
      currBatch.value = val;
      scrollToPageTop();
    };

    // switch page
    const handlePage = (page) => {
      // start laoding
      isLoading.value = true;
      // go back up
      scrollToPageTop();
      // get new page items from function
      getItemsFromApi(`${currUrl.value}${currHook.value}page=${page}`);
    };

    const scrollToPageTop = () => {
      requestAnimationFrame(() => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      });
    };

    // output results
    const batches = computed(() => {
      if (!response.value) {
        return [];
      } else {
        return response.value.data; // get data portion
      }
    });

    // output pages
    const allPages = computed(() => {
      if (!response.value) {
        return [];
      } else {
        return response.value; // get all
      }
    });

    const currentStateTitle = computed(() => {
      return tabsState.value.find((tab) => tab.id === currState.value)?.title || "Everything";
    });

    const emptyBatchTitle = computed(() => {
      if (currState.value === "u") {
        return "No unpaid payment batches";
      }

      if (currState.value === "p") {
        return "No paid payment batches";
      }

      return "No payment batches";
    });

    const emptyBatchDescription = computed(() => {
      if (currState.value === "u") {
        return "There are no pending provider payment batches waiting for finance action.";
      }

      if (currState.value === "p") {
        return "There are no completed provider payment batches in this view.";
      }

      return "There are no provider payment batches available in finance right now.";
    });


    return {
      numberBadge,
      batchTotalApproved,
      backendApprovedTotal,
      toMonthYear,
      handleState,
      handleReset,
      handlePage,
      handleClear,
      handleView,
      tabsState,
      currState,
      currServerDate,
      currBatch,
      currentStateTitle,
      isReady,
      isLoading,
      error,
      batches,
      allPages,
      emptyBatchTitle,
      emptyBatchDescription,
    };
  },
};
</script>
              
<style scoped>
.progress {
  margin: 0;
}

.finance-claims-progress {
  border-radius: 0;
  height: 3px;
  margin: 0 0 10px;
}

.supervisor-claims-workbench {
  color: #263238;
}

.supervisor-claims-frame {
  margin-left: 0;
  margin-right: 0;
}

.supervisor-claims-frame-col {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.premium-queue-head,
.claims-table-head,
.claim-batch-row,
.payment-batch-head {
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 6px;
  box-shadow: none;
}

.premium-queue-head {
  align-items: flex-end;
  background: #ffffff;
  border-color: #f0f0f0;
  box-shadow: none;
  display: flex;
  gap: 22px;
  justify-content: space-between;
  overflow: visible;
  padding: 24px 26px;
  position: relative;
  z-index: 2;
}

.premium-queue-head::before {
  border: 1px solid #c4d3d9;
  border-bottom: 0;
  border-radius: 7px 7px 0 0;
  content: "";
  height: 18px;
  left: -1px;
  pointer-events: none;
  position: absolute;
  right: -1px;
  top: -1px;
  z-index: 1;
}

.premium-queue-head > * {
  position: relative;
  z-index: 2;
}

.queue-title-block h5 {
  color: #263238;
  font-weight: 700;
  margin: 4px 0 0;
}

.queue-title-block p {
  color: #607d8b;
  line-height: 1.45;
  margin: 6px 0 0;
}

.workbench-label {
  color: #607d8b;
  display: block;
  font-size: 0.75rem;
  font-weight: 700;
  margin-bottom: 6px;
  text-transform: uppercase;
}

.scheme-switch {
  background: #f7f7f7;
  border: 1px solid #eeeeee;
  border-radius: 6px;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  padding: 4px;
}

.scheme-switch button {
  background: transparent;
  border: none;
  border-radius: 5px;
  color: #607d8b;
  cursor: pointer;
  font-size: 0.82rem;
  font-weight: 700;
  min-height: 34px;
  padding: 0 14px;
}

.scheme-switch button.is-active {
  background: #263238;
  color: #ffffff;
}

.claims-table-head {
  background: rgba(255, 255, 255, 0.72);
  color: #607d8b;
  font-size: 0.78rem;
  font-weight: 700;
  margin-bottom: 12px;
  padding: 13px 20px;
  text-transform: uppercase;
}

.payment-batch-head {
  color: #607d8b;
  display: grid;
  font-size: 0.76rem;
  font-weight: 700;
  grid-template-columns: 0.55fr 3.7fr 1.6fr 1.5fr 1.6fr 0.7fr;
  letter-spacing: 0;
  margin-bottom: 0;
  margin-top: 0;
  padding: 12px 22px;
  text-transform: uppercase;
}

.claim-batch-row {
  background: #ffffff;
  border-top: 0;
  border-radius: 0;
  margin-bottom: 0;
  padding: 18px 22px;
  transition: background-color 0.18s ease, border-color 0.18s ease;
}

.claim-batch-row .row {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
}

.claim-batch-row.is-open {
  border-color: #eeeeee;
  border-radius: 0 0 6px 6px;
  box-shadow: none;
}

.claim-batch-row:hover {
  background: #fafafa;
}

.row-index {
  color: #607d8b;
  font-weight: 700;
  margin: 0;
}

.provider-cell {
  color: #263238;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.35;
  margin: 0;
}

.provider-cell small,
.period-cell small {
  color: #607d8b;
  font-size: 0.78rem;
  font-weight: 600;
}

.batch-type-pill {
  background: #fafafa;
  border: 1px solid #eeeeee;
  border-radius: 4px;
  color: #607d8b;
  display: inline-block;
  font-size: 0.68rem;
  font-weight: 700;
  line-height: 1;
  margin-left: 7px;
  padding: 5px 8px;
  text-transform: uppercase;
  vertical-align: middle;
}

.bill-count-pill {
  align-items: center;
  background: #eef3f6;
  border: none;
  border-radius: 6px;
  color: #455a64;
  display: inline-flex;
  font-size: 0.85rem;
  font-weight: 700;
  gap: 6px;
  margin-left: 10px;
  min-height: 32px;
  padding: 0 11px;
  vertical-align: middle;
}

.finance-meta-stack {
  align-items: center;
  display: inline-flex;
  flex-direction: column;
  gap: 6px;
}

.finance-meta-stack .bill-count-pill {
  margin-left: 0;
}

.bill-count-pill i {
  color: #607d8b;
}

.claim-batch-row .chip {
  border-radius: 999px;
  font-size: 0.8rem;
  font-weight: 700;
  margin: 0;
  min-width: 0;
  padding: 0 12px;
  text-align: center;
}

.finance-amount-chip {
  background: transparent !important;
  border: 0;
  color: #263238 !important;
  font-size: 1.02rem !important;
  padding: 0 !important;
}

.finance-amount-col {
  text-align: center;
}

.finance-status-col {
  text-align: center;
}

.finance-date-col {
  text-align: center;
}

.finance-action-col {
  text-align: right;
}

.period-cell {
  color: #263238;
  font-weight: 700;
  line-height: 1.35;
  margin: 0;
}

.finance-status-pending {
  background: #fff3e0 !important;
  border: 1px solid #ffe0b2;
  color: #ef6c00 !important;
}

.finance-status-completed {
  align-items: center;
  background: #e8f5e9 !important;
  border: 1px solid #c8e6c9;
  border-radius: 999px !important;
  color: #2e7d32 !important;
  display: inline-flex;
  gap: 5px;
  height: 32px;
  justify-content: center;
  line-height: 32px;
  min-width: 0 !important;
  padding: 0 12px;
  width: fit-content;
}

.finance-status-completed i {
  color: #2e7d32;
  line-height: inherit;
}

.agent-cell {
  background: transparent;
  border-radius: 0;
  color: #455a64;
  display: inline-block;
  font-size: 0.82rem;
  line-height: 1.2;
  margin: 0;
  padding: 0;
}

.paid-date-pill {
  background: transparent;
  border: 0;
  color: #37474f;
}

.row-action {
  align-items: center;
  background: #fafafa;
  border: 1px solid #eeeeee;
  border-radius: 50%;
  color: #607d8b;
  cursor: pointer;
  display: inline-flex;
  height: 36px;
  justify-content: center;
  padding: 0;
  transition: background-color 0.18s ease, color 0.18s ease, transform 0.18s ease;
  width: 36px;
}

.row-action:hover,
.row-action:focus {
  background: #eceff1;
  color: #263238;
  outline: 0;
  transform: translateY(-1px);
}

.row-action.is-close {
  background: #eceff1;
  color: #263238;
}

.row-action.is-close:hover,
.row-action.is-close:focus {
  background: #dfe5e8;
  color: #263238;
}

.row-action i {
  font-size: 20px;
}

.payment-empty-state {
  align-items: center;
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 6px;
  color: #607d8b;
  display: flex;
  flex-direction: column;
  margin-top: 0;
  padding: 38px 18px;
  text-align: center;
}

.payment-empty-icon {
  align-items: center;
  background: #fafafa;
  border: 1px solid #eeeeee;
  border-radius: 6px;
  color: #607d8b;
  display: inline-flex;
  height: 42px;
  justify-content: center;
  margin-bottom: 12px;
  width: 42px;
}

.payment-empty-icon i {
  font-size: 22px;
}

.payment-empty-state h6 {
  color: #263238;
  font-weight: 700;
  margin: 0 0 6px;
}

.payment-empty-state p {
  margin: 0;
}

.spacer10 {
  margin-top: 10px;
  margin-bottom: 10px;
}

.pointer {
  cursor: default;
}

.edit-item:hover .material-icons.grey-text,
.edit-item:hover .material-icons.grey-text::before {
  color: rgb(21, 21, 206) !important;
}

/* open */
.chip-more {
  cursor: pointer;
  background-color: #eaecee !important;
}

.chip-more:hover {
  color: white !important;
  background-color: black !important;
}

/* close */
.chip-less {
  cursor: pointer;
  color: white !important;
  background-color: black !important;
}

.chip-less:hover {
  color: black !important;
  background-color: #eaecee !important;
}

@media only screen and (min-width: 601px) and (max-width: 992px) {
  .premium-queue-head {
    align-items: flex-start;
    flex-direction: column;
    gap: 16px;
    padding: 22px;
  }

  .scheme-switch {
    flex-wrap: nowrap;
    overflow-x: auto;
    width: 100%;
  }

  .scheme-switch button {
    flex: 0 0 auto;
    min-width: 118px;
  }

  .claims-table-head,
  .payment-batch-head {
    display: none;
  }

  .claim-batch-row {
    border-top: 1px solid #eeeeee;
    border-radius: 6px;
    margin-bottom: 10px;
    padding: 18px 20px;
  }

  .claim-batch-row .row {
    display: grid;
    gap: 12px 16px;
    grid-template-columns: 40px minmax(0, 1.2fr) minmax(150px, 0.8fr) 44px;
  }

  .claim-batch-row .col {
    margin: 0;
    padding: 0;
    width: 100% !important;
  }

  .claim-batch-row .row > .col:nth-child(1) {
    grid-column: 1;
    grid-row: 1;
  }

  .claim-batch-row .row > .col:nth-child(2) {
    grid-column: 2 / 4;
    grid-row: 1;
  }

  .claim-batch-row .row > .col:nth-child(3) {
    grid-column: 3;
    grid-row: 1;
  }

  .claim-batch-row .row > .col:nth-child(4) {
    grid-column: 2;
    grid-row: 2;
  }

  .claim-batch-row .row > .col:nth-child(5) {
    grid-column: 3;
    grid-row: 2;
  }

  .claim-batch-row .row > .col:nth-child(6) {
    align-self: center;
    grid-column: 4;
    grid-row: 1 / 4;
    justify-self: end;
  }

  .claim-batch-row .col p {
    margin: 0;
  }

  .finance-amount-col,
  .finance-status-col,
  .finance-date-col {
    background: #f8fafb;
    border: 1px solid #edf1f3;
    border-radius: 6px;
    display: grid;
    gap: 5px;
    min-height: 56px;
    padding: 9px 12px !important;
  }

  .finance-amount-col::before,
  .finance-status-col::before,
  .finance-date-col::before {
    color: #78909c;
    display: block;
    font-size: 0.68rem;
    font-weight: 800;
    letter-spacing: 0.03em;
    line-height: 1;
    text-transform: uppercase;
  }

  .finance-amount-col::before {
    content: "Amount";
  }

  .finance-status-col::before {
    content: "Status";
  }

  .finance-date-col::before {
    content: "Payment date";
  }

  .finance-amount-col,
  .finance-status-col,
  .finance-date-col,
  .finance-action-col {
    text-align: left;
  }

  .finance-action-col.is-close-action {
    grid-column: 1 / -1;
  }

  .finance-action-col.is-close-action > .right {
    display: block;
    float: none !important;
    width: 100%;
  }

  .row-action {
    border-color: #c4d3d9;
    border-radius: 6px;
    height: 40px;
    width: 40px;
  }

  .row-action.is-close {
    border-color: #b0bec5;
    float: none !important;
    width: 100%;
  }
}

@media only screen and (min-width: 601px) and (max-width: 760px) {
  .claim-batch-row .row {
    grid-template-columns: minmax(0, 1fr) 44px;
  }

  .claim-batch-row .row > .col:nth-child(1) {
    display: none;
  }

  .claim-batch-row .row > .col:nth-child(2) {
    grid-column: 1;
    grid-row: 1;
  }

  .claim-batch-row .row > .col:nth-child(3),
  .claim-batch-row .row > .col:nth-child(4),
  .claim-batch-row .row > .col:nth-child(5) {
    grid-column: 1 / -1;
    grid-row: auto;
  }

  .claim-batch-row .row > .col:nth-child(6) {
    grid-column: 2;
    grid-row: 1;
  }

  .claim-batch-row .row > .finance-action-col.is-close-action {
    grid-column: 1 / -1;
    grid-row: auto;
  }
}

@media only screen and (max-width: 600px) {
  .premium-queue-head {
    align-items: flex-start;
    flex-direction: column;
    gap: 16px;
    padding: 20px;
  }

  .queue-title-block h5 {
    font-size: 1.35rem;
    line-height: 1.25;
  }

  .scheme-switch {
    flex-wrap: nowrap;
    overflow-x: auto;
    width: 100%;
  }

  .scheme-switch button {
    flex: 0 0 auto;
    min-width: 118px;
  }

  .claims-table-head,
  .payment-batch-head {
    display: none;
  }

  .claim-batch-row {
    border-top: 1px solid #eeeeee;
    border-radius: 6px;
    margin-bottom: 10px;
    padding: 20px 18px;
  }

  .claim-batch-row .row {
    align-items: stretch;
    display: grid;
    gap: 12px;
    grid-template-columns: minmax(0, 1fr);
  }

  .claim-batch-row .col {
    margin: 0;
    padding: 0;
    width: 100% !important;
  }

  .claim-batch-row .col.s12,
  .claim-batch-row .col.s4,
  .claim-batch-row .col.s6 {
    grid-column: 1 / -1;
  }

  .claim-batch-row .col p {
    margin: 0;
  }

  .provider-cell {
    font-size: 1rem;
  }

  .bill-count-pill {
    margin-left: 0;
    margin-top: 8px;
    width: auto;
  }

  .batch-type-pill {
    margin-left: 0;
    margin-top: 8px;
  }

  .finance-amount-col,
  .finance-status-col,
  .finance-date-col {
    background: #f8fafb;
    border: 1px solid #edf1f3;
    border-radius: 6px;
    display: grid;
    gap: 6px;
    min-height: 58px;
    padding: 10px 12px !important;
    text-align: left;
  }

  .finance-action-col {
    text-align: left;
  }

  .finance-action-col.is-close-action > .right {
    display: block;
    float: none !important;
    width: 100%;
  }

  .finance-amount-col::before,
  .finance-status-col::before,
  .finance-date-col::before {
    color: #78909c;
    display: block;
    font-size: 0.68rem;
    font-weight: 800;
    letter-spacing: 0.03em;
    line-height: 1;
    text-transform: uppercase;
  }

  .finance-amount-col::before {
    content: "Amount";
  }

  .finance-status-col::before {
    content: "Status";
  }

  .finance-date-col::before {
    content: "Payment date";
  }

  .finance-meta-stack,
  .finance-status-completed,
  .finance-status-pending,
  .paid-date-pill,
  .row-action {
    box-sizing: border-box;
    width: 100%;
  }

  .finance-amount-chip,
  .finance-status-pending,
  .finance-status-completed,
  .paid-date-pill {
    justify-content: flex-start;
    padding-left: 0 !important;
    padding-right: 0 !important;
    text-align: left;
  }

  .finance-amount-chip {
    background: transparent !important;
    border-radius: 6px !important;
    color: #263238 !important;
    min-height: 40px;
  }

  .finance-status-pending {
    border-radius: 6px !important;
    display: inline-flex;
    line-height: 38px;
    min-height: 40px;
    padding-left: 12px !important;
    padding-right: 12px !important;
  }

  .paid-date-pill {
    background: transparent;
    border-radius: 6px;
    min-height: 40px;
    padding-top: 0;
  }

  .row-action {
    border-color: #c4d3d9;
    border-radius: 6px;
    float: none !important;
    height: 42px;
    justify-content: center;
  }

  .row-action.is-close {
    border-color: #b0bec5;
    width: 100%;
  }
}
</style>
      
